module.exports = __webpack_public_path__ + "img/ic-info.36620c87.svg";